module.exports = ":host(.small) input {\n  margin: 0; }\n"